import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';
import Event from '@js/components/stock_return/stock-return-event';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const mapToClientObject = stockReturn => {
    stockReturn.return_date = moment(stockReturn.return_date).format();
    return stockReturn;
};

const COMPLETED = 1;
const IN_PROGRESS = 0;

export default {
    namespaced: true,
    state: {
        stockReturn: {
            id: null,
            name: null,
            reference_id: null,
            status: null,
            outlet: {
                id: null,
                name: null,
            },
            supplier: {
                id: null,
                name: null,
            },
            stocks: [],
        },
    },
    getters: {
        stockReturn: state => state.stockReturn,
        hasFinalized: state => state.stockReturn.status == COMPLETED,
        outlet: state => state.stockReturn.outlet,
        supplier: state => state.stockReturn.supplier,
        totalPrice: (state, getters) => {
            return getters.stocks
                .map(stock => {
                    const price = parseFloat(stock.price);
                    const quantity = parseFloat(stock.return_quantity);
                    const validPrice = !_.isNaN(price) && !_.isNaN(quantity);
                    const totalPrice = validPrice ? price * quantity : 0;

                    return parseFloat(totalPrice.toFixed(2));
                })
                .reduce((a, c) => a + c, 0);
        },
        stocks: state => state.stockReturn.stocks,
        findStockIndex: (state, getters) => stock_id => {
            return getters.stocks.findIndex(s => s.stock_id == stock_id);
        },
        completionStatus(state) {
            if (state.stockReturn.status == COMPLETED) return 'Completed';
            return 'In Progress';
        },
    },
    mutations: {
        [types.SET_STOCK_RETURN](state, stockReturn) {
            state.stockReturn = stockReturn;
        },

        [types.SET_STOCK_RETURN_ATTR](state, { key, value }) {
            state.stockReturn[key] = value;
        },

        [types.ADD_RETURN_STOCK](state, stock) {
            state.stockReturn.stocks.push(stock);
        },

        [types.REMOVE_RETURN_STOCK](state, { index }) {
            state.stockReturn.stocks.splice(index, 1);
        },

        [types.UPDATE_RETURN_STOCK](state, { index, key, value }) {
            state.stockReturn.stocks[index][key] = value;
        },
    },
    actions: {
        addReturnStock({ commit, getters }, stockInventory) {
            let price = null;

            // find supplier price if any
            const supplierStock = getters.supplier.stocks.find(
                s => s.id == stockInventory.stock_id,
            );

            if (!_.isNil(supplierStock)) {
                price = supplierStock.pivot.cost;
            } else {
                price = stockInventory.cost;
            }

            const stock = {
                stock_id: stockInventory.stock_id,
                stock: stockInventory,
                current_quantity: stockInventory.quantity,
                return_quantity: null,
                price,
            };

            commit(types.ADD_RETURN_STOCK, stock);
        },

        removeReturnStock({ commit, getters }, stock_id) {
            const stockIndex = getters.findStockIndex(stock_id);

            if (stockIndex >= 0) {
                commit(types.REMOVE_RETURN_STOCK, stockIndex);
            }
        },

        setStockReturnAttr({ commit }, { key, value }) {
            commit(types.SET_STOCK_RETURN_ATTR, { key, value });
        },

        updateReturnStock({ commit, getters }, { stock_id, key, value }) {
            const index = getters.findStockIndex(stock_id);
            commit(types.UPDATE_RETURN_STOCK, { index, key, value });
        },

        async getStockReturn({ dispatch, commit }, id) {
            const url = Laroute.route('stock_returns.show', { id });

            startLoading(dispatch, 'fetch-stock-return');

            try {
                const { data } = await axios.get(url);
                endLoading(dispatch, 'fetch-stock-return');
                commit(types.SET_STOCK_RETURN, mapToClientObject(data));

                return data;
            } catch (e) {
                endLoading(dispatch, 'fetch-stock-return');
                throw e;
            }
        },

        async createStockReturn({ dispatch }, stockReturn) {
            const url = Laroute.route('stock_returns.store');

            startLoading(dispatch, 'save-stock-return');

            try {
                const { data } = await axios.post(url, stockReturn);
                endLoading(dispatch, 'save-stock-return');
                Event.$emit('stock-return-saved');

                return data;
            } catch (e) {
                endLoading(dispatch, 'save-stock-return');
                throw e;
            }
        },

        async updateStockReturn(
            { dispatch, state, commit },
            finalized = false,
        ) {
            let url, method, loader;
            const id = state.stockReturn.id;

            url = finalized
                ? 'stock_returns.finalized'
                : 'stock_returns.update';

            method = finalized ? 'patch' : 'put';
            loader = finalized ? 'ship-stock-return' : 'save-stock-return';

            startLoading(dispatch, loader);

            try {
                const { data } = await axios[method](
                    Laroute.route(url, { id }),
                    state.stockReturn,
                );

                commit(types.SET_STOCK_RETURN, mapToClientObject(data));
                endLoading(dispatch, loader);
                Event.$emit('stock-return-saved');

                return data;
            } catch (e) {
                endLoading(dispatch, loader);
                throw e;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/stock-return.js